import React, { useState , useEffect } from 'react';
import { Briefcase, DollarSign, Users, MapPin, Search, Filter, Check, ArrowRight, Building2, Target, Sparkles } from 'lucide-react';

function PartnersPage({ setCurrentPage }) {
  const [activeFilter, setActiveFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  // Partner startups data
  const partnerStartups = [
    {
      id: 1,
      name: 'TechVenture AI',
      logo: '🤖',
      industry: 'AI & Machine Learning',
      stage: 'Series A',
      location: 'Bangalore',
      description: 'Building next-gen AI solutions for enterprise automation.',
      hiring: true,
      openRoles: 3,
      openToInvestment: true,
      fundingGoal: '₹10 Cr',
      color: '#5DD9C1'
    },
    {
      id: 2,
      name: 'HealthPlus Connect',
      logo: '🏥',
      industry: 'HealthTech',
      stage: 'Seed',
      location: 'Mumbai',
      description: 'Digital health platform with telemedicine and AI diagnostics.',
      hiring: true,
      openRoles: 3,
      openToInvestment: true,
      fundingGoal: '₹5 Cr',
      color: '#FFB6D9'
    },
    {
      id: 3,
      name: 'EduLearn Pro',
      logo: '📚',
      industry: 'EdTech',
      stage: 'Pre-Seed',
      location: 'Delhi',
      description: 'Personalized learning platform using adaptive AI.',
      hiring: true,
      openRoles: 3,
      openToInvestment: true,
      fundingGoal: '₹3 Cr',
      color: '#3D7551'
    },
    {
      id: 4,
      name: 'GreenEnergy Solutions',
      logo: '⚡',
      industry: 'CleanTech',
      stage: 'Series A',
      location: 'Bangalore',
      description: 'Renewable energy management system for businesses.',
      hiring: true,
      openRoles: 3,
      openToInvestment: false,
      fundingGoal: null,
      color: '#5DD9C1'
    },
    {
      id: 5,
      name: 'FinFlow Analytics',
      logo: '💰',
      industry: 'FinTech',
      stage: 'Seed',
      location: 'Hyderabad',
      description: 'AI-powered financial analytics for SMBs.',
      hiring: true,
      openRoles: 3,
      openToInvestment: true,
      fundingGoal: '₹8 Cr',
      color: '#FFB6D9'
    },
    {
      id: 6,
      name: 'AgriTech Innovations',
      logo: '🌾',
      industry: 'AgriTech',
      stage: 'Pre-Seed',
      location: 'Pune',
      description: 'Smart farming with IoT sensors and predictive analytics.',
      hiring: true,
      openRoles: 3,
      openToInvestment: true,
      fundingGoal: '₹4 Cr',
      color: '#3D7551'
    }
  ];

  const filterOptions = [
    { id: 'all', label: 'All Partners' },
    { id: 'hiring', label: 'Hiring Now' },
    { id: 'investing', label: 'Open to Investment' }
  ];

  const filteredStartups = partnerStartups.filter(startup => {
    const matchesFilter = 
      activeFilter === 'all' ||
      (activeFilter === 'hiring' && startup.hiring) ||
      (activeFilter === 'investing' && startup.openToInvestment);
    
    const matchesSearch = 
      startup.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      startup.industry.toLowerCase().includes(searchTerm.toLowerCase());
    
    return matchesFilter && matchesSearch;
  });

  return (
    <div style={{ background: '#FAFBFC', minHeight: '100vh', paddingTop: '2rem' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
        {/* Search Bar */}
        <div style={{ marginBottom: '2.5rem' }}>
          <div style={{ position: 'relative' }}>
            <Search size={20} style={{
              position: 'absolute',
              left: '1.5rem',
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#6B7280'
            }} />
            <input
              type="text"
              placeholder="Search by startup name or industry..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: '100%',
                padding: '1rem 1rem 1rem 3.5rem',
                border: '2px solid #E5E7EB',
                borderRadius: '12px',
                fontSize: '1rem',
                outline: 'none',
                transition: 'all 0.3s',
                background: 'white'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#4A7C5B';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#E5E7EB';
              }}
            />
          </div>
        </div>

        {/* Filter Buttons */}
        <div style={{ marginBottom: '2.5rem' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginBottom: '1rem',
            color: '#4B5563',
            fontSize: '0.95rem',
            fontWeight: '600'
          }}>
            <Filter size={20} />
            <span>Filter:</span>
          </div>
          <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
            {filterOptions.map(option => (
              <button
                key={option.id}
                onClick={() => setActiveFilter(option.id)}
                style={{
                  padding: '0.75rem 1.5rem',
                  borderRadius: '50px',
                  border: 'none',
                  background: activeFilter === option.id ? '#4A7C5B' : 'white',
                  color: activeFilter === option.id ? 'white' : '#4B5563',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '0.9rem',
                  transition: 'all 0.2s',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                }}
                onMouseEnter={(e) => {
                  if (activeFilter !== option.id) {
                    e.target.style.background = '#F3F4F6';
                  }
                }}
                onMouseLeave={(e) => {
                  if (activeFilter !== option.id) {
                    e.target.style.background = 'white';
                  }
                }}
              >
                {option.label}
              </button>
            ))}
            <span style={{ color: '#6B7280', fontSize: '0.95rem', fontWeight: '600', marginLeft: 'auto' }}>
              {filteredStartups.length} startups found
            </span>
          </div>
        </div>

        {/* Partners Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
          gap: '2rem',
          marginBottom: '4rem'
        }}>
          {filteredStartups.map((startup) => (
            <div key={startup.id} style={{
              background: 'white',
              borderRadius: '16px',
              overflow: 'hidden',
              border: '1px solid #E5E7EB',
              transition: 'all 0.3s',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.12)';
              e.currentTarget.style.transform = 'translateY(-4px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
            >
              {/* Header with Logo */}
              <div style={{
                padding: '2rem 1.5rem 1.5rem',
                borderBottom: '1px solid #F3F4F6'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1.25rem',
                  marginBottom: '1.5rem'
                }}>
                  <div style={{
                    fontSize: '2.5rem',
                    width: '60px',
                    height: '60px',
                    background: `${startup.color}15`,
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: `2px solid ${startup.color}30`,
                    flexShrink: 0
                  }}>
                    {startup.logo}
                  </div>
                  <div style={{ flex: 1 }}>
                    <h3 style={{
                      fontSize: '1.4rem',
                      fontWeight: '700',
                      color: '#1F2937',
                      marginBottom: '0.5rem'
                    }}>
                      {startup.name}
                    </h3>
                    <div style={{
                      display: 'inline-block',
                      background: `${startup.color}15`,
                      color: startup.color,
                      padding: '0.35rem 0.875rem',
                      borderRadius: '50px',
                      fontSize: '0.75rem',
                      fontWeight: '700',
                      border: `1px solid ${startup.color}30`
                    }}>
                      {startup.stage}
                    </div>
                  </div>
                </div>

                {/* Location & Industry */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                  fontSize: '0.85rem',
                  color: '#6B7280',
                  marginBottom: '1rem',
                  flexWrap: 'wrap'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                    <MapPin size={14} />
                    {startup.location}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                    <Target size={14} />
                    {startup.industry}
                  </div>
                </div>

                {/* Description */}
                <p style={{
                  color: '#6B7280',
                  lineHeight: 1.6,
                  fontSize: '0.95rem'
                }}>
                  {startup.description}
                </p>
              </div>

              {/* Stats Section */}
              <div style={{
                padding: '1.5rem',
                display: 'flex',
                gap: '1rem',
                borderBottom: '1px solid #F3F4F6'
              }}>
                {startup.hiring && (
                  <div style={{
                    flex: 1,
                    background: '#ECFDF5',
                    padding: '1rem',
                    borderRadius: '12px',
                    textAlign: 'center'
                  }}>
                    <div style={{
                      fontSize: '1.5rem',
                      fontWeight: '700',
                      color: '#059669'
                    }}>
                      {startup.openRoles}
                    </div>
                    <div style={{
                      fontSize: '0.8rem',
                      color: '#047857',
                      fontWeight: '600',
                      marginTop: '0.25rem'
                    }}>
                      Open Roles
                    </div>
                  </div>
                )}

                {startup.openToInvestment && (
                  <div style={{
                    flex: 1,
                    background: '#FEF3F2',
                    padding: '1rem',
                    borderRadius: '12px',
                    textAlign: 'center'
                  }}>
                    <div style={{
                      fontSize: '1.1rem',
                      fontWeight: '700',
                      color: '#DC2626'
                    }}>
                      {startup.fundingGoal}
                    </div>
                    <div style={{
                      fontSize: '0.8rem',
                      color: '#B91C1C',
                      fontWeight: '600',
                      marginTop: '0.25rem'
                    }}>
                      Seeking
                    </div>
                  </div>
                )}
              </div>

              {/* Action Buttons */}
              <div style={{
                padding: '1.5rem',
                display: 'flex',
                gap: '1rem'
              }}>
                {startup.hiring && (
                  <button style={{
                    flex: 1,
                    padding: '0.8rem 1.25rem',
                    background: '#4A7C5B',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontWeight: '600',
                    fontSize: '0.9rem',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = '#3D6849';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = '#4A7C5B';
                  }}
                  >
                    View Jobs <ArrowRight size={16} />
                  </button>
                )}
                <button style={{
                  flex: 1,
                  padding: '0.8rem 1.25rem',
                  background: 'white',
                  color: '#4A7C5B',
                  border: '2px solid #E5E7EB',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: '0.9rem',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#4A7C5B';
                  e.target.style.background = '#F9FAFB';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#E5E7EB';
                  e.target.style.background = 'white';
                }}
                >
                  Profile
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* No Results */}
        {filteredStartups.length === 0 && (
          <div style={{
            textAlign: 'center',
            padding: '4rem 2rem',
            color: '#6B7280'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔍</div>
            <h3 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1F2937', marginBottom: '1rem' }}>
              No startups found
            </h3>
            <p style={{ fontSize: '1rem', marginBottom: '2rem' }}>
              Try adjusting your filters
            </p>
            <button
              onClick={() => {
                setActiveFilter('all');
                setSearchTerm('');
              }}
              style={{
                background: '#4A7C5B',
                color: 'white',
                padding: '0.875rem 2rem',
                borderRadius: '8px',
                border: 'none',
                fontWeight: '600',
                fontSize: '1rem',
                cursor: 'pointer'
              }}
            >
              Clear Filters
            </button>
          </div>
        )}
      </div>

      {/* Enhanced CTA Section */}
      <section style={{
        background: 'linear-gradient(135deg, #4A7C5B 0%, #2C5F3F 100%)',
        padding: '5rem 2rem',
        marginTop: '4rem',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Decorative Elements */}
        <div style={{
          position: 'absolute',
          top: '-100px',
          right: '-100px',
          width: '300px',
          height: '300px',
          background: 'rgba(93, 217, 193, 0.1)',
          borderRadius: '50%',
          filter: 'blur(80px)'
        }}></div>
        <div style={{
          position: 'absolute',
          bottom: '-80px',
          left: '-80px',
          width: '250px',
          height: '250px',
          background: 'rgba(255, 182, 217, 0.08)',
          borderRadius: '50%',
          filter: 'blur(70px)'
        }}></div>

        <div style={{
          maxWidth: '900px',
          margin: '0 auto',
          position: 'relative',
          zIndex: 1,
          textAlign: 'center',
          color: 'white'
        }}>
          {/* Badge */}
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            background: 'rgba(255, 255, 255, 0.15)',
            padding: '0.5rem 1.25rem',
            borderRadius: '50px',
            marginBottom: '1.5rem',
            backdropFilter: 'blur(10px)'
          }}>
            <Building2 size={16} style={{ color: '#5DD9C1' }} />
            <span style={{
              fontSize: '0.85rem',
              fontWeight: '700',
              letterSpacing: '1px'
            }}>
              JOIN OUR ECOSYSTEM
            </span>
          </div>

          <h2 style={{
            fontSize: 'clamp(2.5rem, 5vw, 3.5rem)',
            fontWeight: '800',
            marginBottom: '1.5rem',
            letterSpacing: '-1px'
          }}>
            Ready to Partner With Us?
          </h2>

          <p style={{
            fontSize: '1.2rem',
            opacity: 0.95,
            lineHeight: 1.7,
            marginBottom: '2.5rem',
            maxWidth: '700px',
            margin: '0 auto 2.5rem'
          }}>
            Get access to top talent, investor network, and growth resources. Scale faster with our community support.
          </p>

          {/* Benefits */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
            gap: '1.5rem',
            marginBottom: '3rem',
            maxWidth: '700px',
            margin: '0 auto 3rem'
          }}>
            {[
              { icon: '👥', text: 'Access to Talent' },
              { icon: '💼', text: 'Investor Network' },
              { icon: '📈', text: 'Growth Support' },
            ].map((benefit, i) => (
              <div key={i} style={{
                background: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(10px)',
                padding: '1.25rem',
                borderRadius: '12px',
                border: '1px solid rgba(255, 255, 255, 0.15)'
              }}>
                <div style={{ fontSize: '1.75rem', marginBottom: '0.5rem' }}>{benefit.icon}</div>
                <div style={{ fontSize: '0.9rem', fontWeight: '600' }}>{benefit.text}</div>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <button
              onClick={() => setCurrentPage && setCurrentPage('login')}
              style={{
                background: 'white',
                color: '#2C5F3F',
                padding: '1.25rem 3rem',
                borderRadius: '12px',
                fontSize: '1.1rem',
                fontWeight: '700',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s',
                boxShadow: '0 8px 25px rgba(0, 0, 0, 0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-3px)';
                e.target.style.boxShadow = '0 12px 35px rgba(0, 0, 0, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.2)';
              }}
            >
              Apply as Partner
              <ArrowRight size={20} />
            </button>

            <button
              onClick={() => setCurrentPage && setCurrentPage('contact')}
              style={{
                background: 'transparent',
                color: 'white',
                padding: '1.25rem 3rem',
                borderRadius: '12px',
                fontSize: '1.1rem',
                fontWeight: '700',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                cursor: 'pointer',
                transition: 'all 0.3s',
                backdropFilter: 'blur(10px)'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255, 255, 255, 0.15)';
                e.target.style.borderColor = 'white';
                e.target.style.transform = 'translateY(-3px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              Get in Touch
            </button>
          </div>

          {/* Info */}
          <p style={{
            marginTop: '2rem',
            fontSize: '0.9rem',
            opacity: 0.85
          }}>
            ⚡ Join 50+ partner startups growing together
          </p>
        </div>
      </section>
    </div>
  );
}

export default PartnersPage;
